import { productIcons } from '../assets/logos/index.js';

/**
 * Create a decorative icon. The calling component supplies the accessible name.
 * @param {string} productId
 * @param {Document} [ownerDocument] Target document for components inside an iframe.
 * @returns {SVGSVGElement}
 */
export function createProductIcon(productId, ownerDocument = globalThis.document) {
  if (!Object.prototype.hasOwnProperty.call(productIcons, productId)) {
    throw new Error(`[PositiveNav] Unknown product icon: ${productId}`);
  }

  if (!ownerDocument) {
    throw new Error('[PositiveNav] createProductIcon() requires a DOM.');
  }

  const template = ownerDocument.createElement('template');
  // Only local SVGs prepared at build time are inserted here.
  template.innerHTML = productIcons[productId];
  const icon = template.content.firstElementChild;

  icon.classList.add('positive-nav-logo');
  icon.setAttribute('aria-hidden', 'true');
  icon.setAttribute('focusable', 'false');
  icon.style.color = 'var(--positive-nav-logo-color, inherit)';
  icon.style.width = 'var(--positive-nav-icon-size, var(--positive-nav-default-icon-size, 32px))';
  icon.style.height = 'var(--positive-nav-icon-size, var(--positive-nav-default-icon-size, 32px))';

  return icon;
}
